"use client";

import { JURISDICTIONS } from "@/lib/constants";
import StatsBar from "./StatsBar";
import ArticleCard from "./ArticleCard";

export default function FeedView({
  activeJur,
  loading,
  classifying,
  saving,
  searchingJur,
  freshArticles,
  currentStored,
  error,
  onFetch,
  onToggleRelevance,
  onStopSearch,
}) {
  const jurData = JURISDICTIONS.find((j) => j.id === activeJur);
  const jurName = jurData?.name;
  const jurColor = jurData?.color || "#FF5D31";
  const searchBusy = !!searchingJur;

  return (
    <div>
      {(loading || classifying || saving) && (
        <div style={{ textAlign: "center", padding: "50px 20px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              border: "2.5px solid #DCD6C7",
              borderTop: `2.5px solid ${jurColor}`,
              borderRadius: "50%",
              margin: "0 auto 14px",
              animation: "spin 0.9s linear infinite",
            }}
          />
          <p style={{ fontSize: "14px", fontFamily: "var(--font-serif)", color: "#464644", margin: "0 0 10px" }}>
            {loading && <>Searching <em>{jurName}</em>&hellip;</>}
            {classifying && <>Classifying articles&hellip;</>}
            {saving && <>Saving to database&hellip;</>}
          </p>
          <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            fontSize: "11px",
            fontFamily: "var(--font-mono)",
            color: "#999999",
          }}>
            <span style={{ color: loading ? jurColor : "#43695B" }}>
              {loading ? "\u25C9" : "\u2713"} search
            </span>
            <span style={{ color: classifying ? jurColor : saving ? "#43695B" : "#DCD6C7" }}>
              {classifying ? "\u25C9" : saving ? "\u2713" : "\u25CB"} classify
            </span>
            <span style={{ color: saving ? jurColor : "#DCD6C7" }}>
              {saving ? "\u25C9" : "\u25CB"} save
            </span>
          </div>
          <button
            onClick={onStopSearch}
            style={{
              marginTop: "16px",
              padding: "4px 14px",
              border: "1px solid #DCD6C7",
              borderRadius: "3px",
              backgroundColor: "transparent",
              color: "#999999",
              fontSize: "11px",
              fontFamily: "var(--font-mono)",
              cursor: "pointer",
            }}
          >
            Stop
          </button>
        </div>
      )}

      {searchBusy && searchingJur !== activeJur && (
        <div
          style={{
            padding: "10px 16px",
            backgroundColor: "#fff",
            borderRadius: "4px",
            border: "1px solid #DCD6C7",
            marginBottom: "14px",
            fontSize: "13px",
            fontFamily: "var(--font-mono)",
            color: "#70706E",
          }}
        >
          Searching {JURISDICTIONS.find((j) => j.id === searchingJur)?.name}&hellip;
        </div>
      )}

      {freshArticles.length > 0 && (
        <>
          <div
            style={{
              marginBottom: "10px",
              fontSize: "12px",
              fontFamily: "var(--font-mono)",
              color: "#43695B",
            }}
          >
            &#10003; {freshArticles.length} new articles found and saved
          </div>
          <StatsBar articles={freshArticles} />
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {freshArticles.map((art, i) => (
              <div
                key={art.url || i}
                style={{ animation: `fadeUp 0.3s ease ${i * 0.04}s both` }}
              >
                <ArticleCard article={art} onToggleRelevance={onToggleRelevance} />
              </div>
            ))}
          </div>
        </>
      )}

      {!loading && !classifying && freshArticles.length === 0 && !error && (
        <div style={{ textAlign: "center", padding: "40px 20px", color: "#999999" }}>
          <p
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "16px",
              margin: "0 0 6px",
              color: "#464644",
            }}
          >
            <em>{jurName}</em> &mdash; Daily Feed
          </p>
          <p style={{ fontSize: "13px", fontFamily: "var(--font-sans)", margin: "0 0 4px" }}>
            {currentStored.length > 0
              ? `${currentStored.filter((a) => a.classification?.relevant).length} relevant articles in database. Use "Daily Search" for today's news or "Deep Search" to catch anything missed.`
              : 'Use "Daily Search" for today\'s articles or "Deep Search" to pull the past two weeks.'}
          </p>
        </div>
      )}
    </div>
  );
}
